import { useState } from 'react';
import { Icon } from '../../components/Icon.tsx';

/**
 * 홈 화면에 추가하기 안내 — Home 위쪽.
 *
 * **이 한 줄이 7일 주기를 끝냅니다.** 무료 계정으로 서명한 IPA 는 애플이
 * 프로비저닝 프로파일에 7일을 박아 두어 그때마다 다시 설치해야 하지만,
 * 홈 화면에 추가한 웹앱은 만료가 없습니다. 그런데 **iOS 는 설치하라고
 * 먼저 물어봐 주지 않습니다** — 안드로이드와 달리 설치 배너가 없어서,
 * 사파리 공유 메뉴를 열어 「홈 화면에 추가」를 직접 눌러야 합니다.
 * 아무도 알려 주지 않으면 그 길이 있는 줄 모릅니다.
 *
 * 이미 홈 화면에서 열었으면 뜨지 않습니다. 한 번 닫으면 다시 뜨지 않습니다 —
 * 읽고 나면 쓸모가 없어지는 안내라 계속 자리를 차지할 이유가 없습니다.
 */

const DISMISSED = 'prayerlog.install-hint.dismissed';

/** 홈 화면에서 연 판인가 — 그렇다면 안내할 것이 없습니다 */
function isStandalone(): boolean {
  try {
    if (window.matchMedia('(display-mode: standalone)').matches) return true;
    // iOS 사파리는 표준 display-mode 대신 이 비표준 값을 씁니다
    return (window.navigator as { standalone?: boolean }).standalone === true;
  } catch {
    return false;
  }
}

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED) === '1';
  } catch {
    // 사파리 프라이빗 모드 등에서 막힐 수 있습니다. 그때는 그냥 보여 줍니다
    return false;
  }
}

export function InstallHint() {
  const [hidden, setHidden] = useState(() => isStandalone() || wasDismissed());

  if (hidden) return null;

  const close = () => {
    setHidden(true);
    try {
      localStorage.setItem(DISMISSED, '1');
    } catch {
      /* 못 적어도 이번 세션 동안은 닫힙니다 */
    }
  };

  return (
    <aside className="install">
      <div className="install__head">
        <Icon name="plus" size={16} />
        <b>홈 화면에 추가해 두세요</b>
        <button type="button" className="install__x" aria-label="닫기" onClick={close}>
          <Icon name="close" size={15} />
        </button>
      </div>

      <p className="install__body">
        앱처럼 전체 화면으로 열리고, <b>다시 설치할 필요가 없습니다.</b>
      </p>

      {/* 사파리 메뉴 이름을 그대로 적습니다 — 옮겨 적으면 못 찾습니다 */}
      <p className="install__how">
        사파리 아래쪽 <b>공유</b>
        <Icon name="share" size={13} />를 누르고 <b>「홈 화면에 추가」</b>
      </p>
    </aside>
  );
}
